import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import AOS from 'aos';

// Images 
import residential_icon from '../../images/liaison/micro-landing/residential.png'
import industry_icon from '../../images/liaison/micro-landing/industry.png'
import education_icon from '../../images/liaison/micro-landing/educational.png'
import healthcare_icon from '../../images/liaison/micro-landing/healthcare.png'
import laptop from '../../images/liaison/micro-landing/lap_mockup.png'
import login_icon from '../../images/liaison/micro-landing/login_icon.png'
import sitevist_icon from "../../images/liaison/micro-landing/sitevist_icon.png"
import proposal_icon from '../../images/liaison/micro-landing/proposal_icon.png'
import dotted_line from '../../images/liaison/micro-landing/line.png'


function Liaison_Description() {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    const params = useParams();
    const path = params.micro_id;


    let [show, setShow] = useState(false);

    useEffect(() => {
        if (path === "retail" || path === "development" || path === "commerical") {
            setShow(true);
        }
        else {
            setShow(false);
        }
    }, [])

    // Liaison Description

    const data = {

        dtcp: {
            heading: "DTCP Building Plan Approval",
            content_classname: "max-w-[835px]",
            content: "If you are building a residence, commercial property, industry, or institution, we assist you in obtaining approvals for your building plan in compliance with the regulations of the Directorate of Town and Country Planning (DTCP).",
        },

        landuse: {
            heading: "Land Use Change",
            content_classname: "max-w-[835px]",
            content: "Are you planning to transform agricultural land into a thriving residential, commercial, industrial, or medical facility? We will help you through the land conversion based on government laws and regulations quickly and efficiently.",
        },

        layoutapproval: {
            heading: "Layout Approval",
            content_classname: "max-w-[806px]",
            content: "Transform a barren land into a thriving housing community with our design principles that optimize land usability and enhance saleability. Our design principles strictly adhere to government mandates, creating a sought-after locality for both Residential living and Investment opportunities.",
        },

        hacanoc: {
            heading: "HACA NOC",
            content_classname: "max-w-[796px]",
            content: "If your assets are in environmentally sensitive areas like Hills, near Forests & Seas you might have to seek approval from government departments to effectively put the Land to use, be it for construction, sale or any other intent to develop. Lands and Lands will help you obtain those approvals.",
        },
    };

    // Service platform

    const Service_Card = [
        {
            img: residential_icon,
            heading: "Residential"
        },
        {
            img: industry_icon,
            heading: "Industry"
        },
        {
            img: education_icon,
            heading: "Educational"
        },
        {
            img: healthcare_icon,
            heading: "Healthcare"
        },

    ]

    // Login process

    const loginProcess = [
        {
            icon: login_icon,
            Heading: "Login",
        },
        {
            icon: sitevist_icon,
            Heading: "Site vist",
        },
        {
            icon: proposal_icon,
            Heading: "proposal",
        },



    ]



    return (
        <div className="max-w-full mx-auto mt-10 px-5 lg:px-0">

            <div className="max-w-[822px] mx-auto my-[30px] md:my-[90px]">
                <h1 className={"font-noto text-[#17212B] text-[32px] sm:text-[45px] font-bold text-center mx-auto" + data[path].heading_classname} data-aos="fade-up">{data[path].heading}</h1>
                <hr className='border-yellow border-[2px] w-[87px] mx-auto my-[25px]' data-aos="fade-up" />
                <p className="service-description max-w-[822px] mx-auto" data-aos="fade-up">{data[path].content} </p>
            </div>


            {/* Service Card */}

            <div className="max-w-[1250px] mx-auto flex flex-wrap justify-between gap-6">
                {
                    Service_Card.map((items) => {

                        return (


                            <div className="w-[294px] h-fit bg-grey mx-auto py-[50px] sm:h-[308px] sm:py-[70px]" data-aos="fade-up">
                                <img className="w-[60px] sm:w-[80px] sm:h-[80px] mx-auto" src={items.img} alt="icons" />
                                <h1 className="font-noto text-[#17212B] text-[24px] font-bold text-center mt-[28px] sm:mt-[60px]">{items.heading}</h1>
                            </div>
                        )
                    })
                }
            </div>

            {/* Login Steps */}

            <div className="max-w-full  mx-auto bg-grey p-2 relative  my-[60px] lg:mt-[450px] lg:h-[750px] ">

                <img className="lg:-mt-[300px] w-[950px] mx-auto" src={laptop} alt="laptop" data-aos="fade-up" />

                {/* Heading */}
                <div className="my-6 mx-auto">
                    <h1 className='heading' data-aos="fade-up">You will need a few things to sign up</h1>


                    <div className="my-[60px] flex flex-col sm:flex-row justify-center gap-8 sm:gap-3 lg:gap-10 relative">
                        <img className="w-[927px] absolute top-10 hidden lg:block" src={dotted_line} alt="dottedline" data-aos="fade-up" />
                        {
                            loginProcess.map((items) => {
                                return (
                                    <div className="lg:w-[239px] h-fit text-center space-y-[20px] z-40 mx-auto lg:mx-0" data-aos="fade-up">
                                        <img className="w-[89px] mx-auto" src={items.icon} alt="icons" />
                                        <h1 className="font-noto text-[20px] font-bold sm:text-[22px]">{items.Heading}</h1>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>

        </div>



    )
}


export default Liaison_Description